module.exports = __webpack_public_path__ + "img/car_status_driving.6938e49f.svg";